import React,{useState,useEffect,useContext} from 'react'
import { Link } from 'react-router-dom'
import axios from 'axios'
import { ToastContainer, toast } from "react-toastify";
import { AuthContextUser } from "../context/UserContext";
// /StudentRegister/register
export const Register = () => {

  const { currentUser } = useContext(AuthContextUser);

  const [tokenID, settokenID] = useState("");

  useEffect(() => {
    settokenID(Math.floor(Math.random() * 9652805) + 15);
  }, []);

  const [name,setName] = useState('')
  const [meli,setMeli] = useState('')
  const [nezam,setNezam] = useState('')
  const [io1,setIo1] = useState('')
  const [io2,setIo2] = useState('')
  const [password,setPassword] = useState('')
  const [tel,setTel] = useState('')

  const RegisterStudent = async() =>{
    try{
      if(!name || !password || !tel || !io1 || !io2){
        toast.warning("لطفا تمامی موارد خواسته شده را پر نمائید")
      }else{

    await axios.post("https://clinic.salamatpayanew.ir/Register/register",{
      name:name,
      meli:meli,
      password:password,
      tel:tel,
      type:io1,
      type2:io2,
      nezam:nezam
      //dr_meli:dr_meli
    })
    toast.success("عملیات ثبت نام با موفقیت انجام شد - منتظر تایید مدیر بمانید")
  }
  }catch(e){
    toast.error("خطا در ایجاد ردیف")
  }
}

if (currentUser.tel === null) {
} else {
  return (
   <>
    <div class="container-fluid wrapper" dir='rtl'>
    <div class="row d-flex align-items-center h-100">
      <div class="col-sm-12 auth-responsive d-flex d-xl-none"><img src="./img/WLogo.png" width="200" alt="" />
      </div>
      <div class="col-sm-12 col-xl-3 d-flex justify-content-center align-items-center p-24">
        <div class="card auth-shadow login-card position-relative order-1">
          <img src="../img/Rec01.png" alt="" class="position-absolute order-0 auth-rec1" />
          <img src="../img/Rec01.png" alt="" class="position-absolute order-0 auth-rec2" />
          <img src="../img/Rec01.png" alt="" class="position-absolute order-0 auth-rec1 bottom-0" />
          <div class="card-header bg-white border-0 p-0">
            <div class="card-title text-center">
              <h1>کاربر</h1>
              <p>
                 اطلاعات حساب کاربری خود را وارد
                کنید
              </p>
            </div>
          </div>
          <div class="card-content auth-card">
            <div class="form-group position-relative d-flex align-items-center justify-content-center mb-0">
              <i class="zmdi zmdi-account text-danger"></i>
              <input type="text" class="form-control  border-danger" maxLength={20} placeholder="نام و نام خانوادگی"  onChange={(e) => setName(e.target.value)} />
            </div>
            <div class="form-group position-relative d-flex align-items-center justify-content-center mb-0">
              <i class="zmdi zmdi-edit text-danger"></i>
              <input type="text" class="form-control  border-danger" maxLength={10} placeholder="کد ملی"  onChange={(e) => setMeli(e.target.value)} />
            </div>
            <div class="form-group position-relative d-flex align-items-center justify-content-center">
              <i class="zmdi zmdi-key"></i>
              <input type="password" maxLength={10} class="form-control" placeholder="کلمه عبور"  onChange={(e) => setPassword(e.target.value)}/>
            </div>
            <div class="form-group position-relative d-flex align-items-center justify-content-center">
              <i class="zmdi zmdi-hc-fw"></i>
              <select class="form-select form-control" aria-label="Default select example"  onChange={(e) => setIo1(e.target.value)}>
                <option selected>انتخاب سمت</option>
                <option value="پزشک">پزشک</option>
                <option value="پرستار">پرستار</option>
                <option value="منشی">منشی</option>
                <option value="کارآموز">کارآموز</option>
                <option value="سایر">سایر</option>
              </select>
            </div>
            <div class="form-group position-relative d-flex align-items-center justify-content-center">
            <i class="zmdi zmdi-assignment-account"></i>
              <select class="form-select form-control" aria-label="Default select example"  onChange={(e) => setIo2(e.target.value)}>
                <option selected>جنسیت</option>
                <option value="خانم">خانم</option>
                <option value="آقا">آقا</option>
              </select>
            </div>
            <div class="form-group position-relative d-flex align-items-center justify-content-center">
              <input type="text" name="" placeholder="09170000000" maxLength={11} class="form-control input-number text-end" id="" onChange={(e) => setTel(e.target.value)} />
              <div class="position-absolute left-0 select-number-icon-wrapper">
                <div class="devider"></div>
                <img src="../img/Flag Pack.png" alt="" />
                <img src="../icons/select arrow.svg" alt="" />
              </div>
            </div>
            <div class="form-group position-relative d-flex align-items-center justify-content-center">
              <input type="text" name="" placeholder="کد نظام پزشکی" maxLength={6} class="form-control input-number text-end" id="" onChange={(e) => setNezam(e.target.value)} />
            </div>
            <button class="custom-btn-primary w-100" onClick={RegisterStudent}>
              ساخت حساب
            </button>
            <p class="t-24 text-center mb-0">
              حساب داری؟ <Link to="/">ورود به حساب</Link>
            </p>
          </div>
        </div>
      </div>
      <div class="col-sm-12 col-xl-9 d-none d-xl-flex justify-content-center align-items-center p-24 h-100 pr-0">
        <div class="auth-section-img position-relative d-flex justify-content-center align-items-center">
          <div class="position-absolute d-flex flex-column justify-content-center align-items-center">
            <img src="../img/WLogo.png" width="250" alt="" />
            <div class="d-flex flex-column">
              <h3>سلامت پایا</h3>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <ToastContainer
        position="top-center"
        autoClose={20000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />

   </>
  )
}
}
